import React from "react";
import { FaBars } from "react-icons/fa";
import { useSpring, animated } from "@react-spring/web";

export default function Menu({ toggleMenu }) {
    // Rung nhẹ và ngẫu nhiên
    const animation = useSpring({
        from: { transform: "scale(1) rotate(0deg)", opacity: 1 },
        to: async (next) => {
            while (true) {
                const rotate = (Math.random() - 0.5) * 10; // dao động ngẫu nhiên -5 đến +5 độ
                const scale = 1 + (Math.random() - 0.5) * 0.1; // dao động scale nhẹ 0.95–1.05
                const opacity = 0.8 + Math.random() * 0.2; // 0.8–1.0
                await next({
                    transform: `scale(${scale}) rotate(${rotate}deg)`,
                    opacity,
                });
            }
        },
        config: { tension: 200, friction: 10 }, // nhanh hơn, hồi mượt
    });

    return (
        <div
            className="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none"
            style={{ paddingLeft: 'max(env(safe-area-inset-left), 0.5rem)' }}
        >
            <button
                onClick={toggleMenu}
                className="nav-item bg-transparent w-10 h-10 flex items-center justify-center cursor-pointer"
            >
                <animated.div style={animation}>
                    <FaBars size={28} className="text-purple-500 hover:text-purple-400 transition duration-300" />
                </animated.div>
            </button>
        </div>
    );
}
